import { Stack } from "@mui/material";
import React, { FC } from "react";
import { FieldValues } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { NumberInput, useMuiController } from "@sinch/components/index";

export const WorkedDurationSettings: FC<{ disabled?: boolean; path?: string }> = ({ disabled, path = "settings" }) => {
  const { t } = useTranslation();
  const { field: fromField } = useMuiController<FieldValues, string>({
    name: `${path}.fromAmountOfHours`,
    disabled,
  });
  const { field: toField } = useMuiController<FieldValues, string>({
    name: `${path}.toAmountOfHours`,
    disabled,
  });

  return (
    <Stack spacing={2}>
      <NumberInput {...fromField} fullWidth label={t("RateUnit.durationFrom")} min={0} />
      <NumberInput {...toField} fullWidth label={t("RateUnit.durationTo")} min={fromField.value} />
    </Stack>
  );
};
